import Page from 'components/modules/public/pages/Faq';
export default Page;